import throttle from 'lodash/throttle';

const ZOOM_CLASS_PREFIX = 'ol-zoom--';

/**
 * @param {import('ol').Map} map map
 */
export function addZoomClassToViewport(map) {
	const view = map.getView();
	const viewPort = map.getViewport();
	let currentZoomLevel;

	function set() {
		currentZoomLevel = Math.round(view.getZoom());
		viewPort.classList.add(`${ZOOM_CLASS_PREFIX}${currentZoomLevel}`);
	}

	function remove() {
		viewPort.classList.remove(`${ZOOM_CLASS_PREFIX}${currentZoomLevel}`);
	}

	const throttledUpdate = throttle(
		() => {
			remove();
			set();
		},
		200,
		{leading: false, trailing: true}
	);

	view.on('change:resolution', () => {
		throttledUpdate();
	});
	set();
}
